import * as THREE from "three";
import { createHotspotLayer } from "./hotspots_layer";
import { createInteractions } from "./interactions";
import { createToolboxesPanel } from "./toolboxes_panel";
import { initToolsDragDrop } from "./tools_drag_drop";
import { initWorkflowRuntime } from "./workflow_runtime_manager";

// ATTENZIONE! rimosso per ora
// import { loadScene } from "./scene_loader";

export function startViewer(el, { scene: sceneData } = {}) {
  const computedPos = window.getComputedStyle(el).position;
  if (computedPos === "static") {
    el.style.position = "relative";
  }
  el.style.overflow = "hidden";

  const workflowRuntime = initWorkflowRuntime({ sceneData });

  /* =========================
   * WORKFLOW HUD
   * ========================= */
  let workflowHudEl = document.getElementById("workflow-hud");
  let workflowHudProgressTextEl = document.getElementById("workflow-hud-progress");
  let workflowHudStepsEl = document.getElementById("workflow-hud-steps");
  let workflowHudToolsWrapEl = document.getElementById("workflow-hud-tools-wrap");
  let workflowHudToolsListEl = document.getElementById("workflow-hud-tools-list");

  function ensureWorkflowHud() {
    if (!workflowHudEl) {
      workflowHudEl = document.getElementById("workflow-hud");
      workflowHudProgressTextEl = document.getElementById("workflow-hud-progress");
      workflowHudStepsEl = document.getElementById("workflow-hud-steps");
      workflowHudToolsWrapEl = document.getElementById("workflow-hud-tools-wrap");
      workflowHudToolsListEl = document.getElementById("workflow-hud-tools-list");
    }
    return workflowHudEl;
  }

  function getStepTone(step, index) {
    const { completedSteps, skippedSteps, currentIndex } = workflowRuntime.state;

    if (completedSteps.includes(step)) return "done";
    if (skippedSteps.includes(step)) return "skipped";
    if (index === currentIndex && !workflowRuntime.isCompleted()) return "current";
    return "future";
  }

  function labelForStep() {
    return "";
  }

  function applyWorkflowHudBaseStyles() {
    if (!workflowHudEl || !workflowHudProgressTextEl || !workflowHudStepsEl || !workflowHudToolsWrapEl || !workflowHudToolsListEl) return;

    workflowHudEl.style.position = "absolute";
    workflowHudEl.style.top = "10px";
    workflowHudEl.style.left = "10px";
    workflowHudEl.style.zIndex = "70";
    workflowHudEl.style.width = "min(300px, calc(100vw - 32px))";
    workflowHudEl.style.pointerEvents = "none";
    workflowHudEl.style.display = "flex";
    workflowHudEl.style.flexDirection = "column";
    workflowHudEl.style.gap = "8px";

    const card = workflowHudEl.querySelector(".workflow-hud__card");
    const header = workflowHudEl.querySelector(".workflow-hud__header");
    const title = workflowHudEl.querySelector(".workflow-hud__title");
    const toolsTitle = workflowHudEl.querySelector(".workflow-hud__tools-title");

    if (card) {
      card.style.background = "rgba(10, 14, 24, 0.42)";
      card.style.border = "1px solid rgba(255,255,255,0.16)";
      card.style.borderRadius = "16px";
      card.style.padding = "9px 10px 8px";
      card.style.backdropFilter = "blur(12px)";
      card.style.webkitBackdropFilter = "blur(12px)";
      card.style.boxShadow = `
        0 10px 28px rgba(0,0,0,0.24),
        inset 0 1px 0 rgba(255,255,255,0.10),
        0 0 0 1px rgba(255,255,255,0.03)
      `;
      card.style.display = "flex";
      card.style.flexDirection = "column";
      card.style.gap = "6px";
    }

    if (header) {
      header.style.display = "flex";
      header.style.justifyContent = "space-between";
      header.style.alignItems = "center";
      header.style.gap = "8px";
    }

    if (title) {
      title.style.color = "rgba(255,255,255,0.96)";
      title.style.fontSize = "12px";
      title.style.fontWeight = "900";
      title.style.letterSpacing = "0.04em";
      title.style.textTransform = "uppercase";
      title.style.textShadow = "0 1px 8px rgba(0,0,0,0.35)";
    }

    workflowHudProgressTextEl.style.color = "rgba(255,255,255,0.82)";
    workflowHudProgressTextEl.style.fontSize = "11px";
    workflowHudProgressTextEl.style.fontWeight = "800";
    workflowHudProgressTextEl.style.padding = "3px 7px";
    workflowHudProgressTextEl.style.borderRadius = "999px";
    workflowHudProgressTextEl.style.background = "rgba(255,255,255,0.08)";
    workflowHudProgressTextEl.style.border = "1px solid rgba(255,255,255,0.10)";

    workflowHudStepsEl.style.display = "grid";
    workflowHudStepsEl.style.gridTemplateColumns = "repeat(auto-fit, minmax(16px, 1fr))";
    workflowHudStepsEl.style.gap = "5px";
    workflowHudStepsEl.style.marginBottom = "-6px";

    workflowHudToolsWrapEl.style.display = "flex";
    workflowHudToolsWrapEl.style.flexDirection = "column";
    workflowHudToolsWrapEl.style.gap = "4px";
    workflowHudToolsWrapEl.style.paddingTop = "0px";
    workflowHudToolsWrapEl.style.marginTop = "0px";  
    workflowHudToolsWrapEl.style.borderTop = "1px solid rgba(255,255,255,0.08)";

    if (toolsTitle) {
      toolsTitle.style.color = "rgba(255,255,255,0.84)";
      toolsTitle.style.fontSize = "11px";
      toolsTitle.style.fontWeight = "900";
      toolsTitle.style.letterSpacing = "0.03em";
      toolsTitle.style.textTransform = "uppercase";
      toolsTitle.style.marginTop = "4px";
    }

    workflowHudToolsListEl.style.display = "flex";
    workflowHudToolsListEl.style.flexDirection = "column";
    workflowHudToolsListEl.style.gap = "6px";
  }

  function renderWorkflowHudSteps() {
    ensureWorkflowHud();
    if (!workflowHudStepsEl || !workflowHudProgressTextEl) return;

    const { steps, completedSteps, skippedSteps } = workflowRuntime.state;
    workflowHudStepsEl.innerHTML = "";

    const total = steps.length;
    const doneCount = completedSteps.length;
    const skippedCount = skippedSteps.length;

    if (!total) {
      workflowHudProgressTextEl.textContent = "0 / 0";
      const empty = document.createElement("div");
      empty.textContent = "Nessun workflow";
      empty.style.gridColumn = "1 / -1";
      empty.style.color = "rgba(255,255,255,0.68)";
      empty.style.fontSize = "13px";
      empty.style.textAlign = "center";
      empty.style.padding = "10px 0";
      workflowHudStepsEl.appendChild(empty);
      return;
    }

    workflowHudProgressTextEl.textContent = `${doneCount + skippedCount} / ${total}`;

    steps.forEach((step, index) => {
      const tone = getStepTone(step, index);

      const chip = document.createElement("div");
      chip.className = `workflow-step-chip workflow-step-chip--${tone}`;
      chip.title = `Step ${index + 1} • ${step.kind} • ${step.severity || "required"}`;
      chip.style.position = "relative";
      chip.style.height = "18px";
      chip.style.minWidth = "20px";
      chip.style.borderRadius = "8px";
      chip.style.display = "flex";
      chip.style.alignItems = "center";
      chip.style.justifyContent = "center";
      chip.style.fontSize = "0";
      chip.style.fontWeight = "900";
      chip.style.letterSpacing = "0";
      chip.style.textShadow = "none";
      chip.style.border = "1px solid rgba(255,255,255,0.12)";
      chip.style.boxShadow = "0 4px 10px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.10)";
      chip.style.transition = "transform 180ms ease, box-shadow 180ms ease";

      if (tone === "done") {
        chip.style.background = "linear-gradient(180deg, rgba(34,197,94,0.96), rgba(22,163,74,0.88))";
        chip.style.border = "1px solid rgba(187,247,208,0.38)";
        chip.style.boxShadow = `
          0 0 0 1px rgba(34,197,94,0.16),
          0 6px 16px rgba(12,90,42,0.30),
          inset 0 1px 0 rgba(255,255,255,0.14)
        `;
        chip.style.color = "#f0fff4";
      } else if (tone === "skipped") {
        chip.style.background = "linear-gradient(180deg, rgba(249,115,22,0.96), rgba(217,119,6,0.88))";
        chip.style.border = "1px solid rgba(253,186,116,0.40)";
        chip.style.boxShadow = `
          0 0 0 1px rgba(249,115,22,0.14),
          0 6px 16px rgba(120,60,0,0.28),
          inset 0 1px 0 rgba(255,255,255,0.14)
        `;
        chip.style.color = "#fff7ed";
      } else if (tone === "current") {
        chip.style.background = "linear-gradient(180deg, rgba(59,130,246,0.96), rgba(37,99,235,0.88))";
        chip.style.border = "1px solid rgba(147,197,253,0.42)";
        chip.style.boxShadow = `
          0 0 0 1px rgba(59,130,246,0.18),
          0 0 18px rgba(59,130,246,0.22),
          0 6px 16px rgba(17,64,140,0.28),
          inset 0 1px 0 rgba(255,255,255,0.16)
        `;
        chip.style.color = "#eff6ff";
        chip.style.transform = "translateY(-1px)";
      } else {
        chip.style.background = "linear-gradient(180deg, rgba(71,85,105,0.72), rgba(51,65,85,0.68))";
        chip.style.border = "1px solid rgba(255,255,255,0.10)";
        chip.style.color = "rgba(255,255,255,0.78)";
      }

      chip.textContent = labelForStep(step, index);
      workflowHudStepsEl.appendChild(chip);
    });
  }

  function renderWorkflowHudTools() {
    ensureWorkflowHud();
    if (!workflowHudToolsListEl) return;

    const completedToolSteps = workflowRuntime.state.completedSteps.filter(
      (step) => step?.kind === "tool_click"
    );

    workflowHudToolsListEl.innerHTML = "";
    workflowHudToolsListEl.style.display = "block";
    workflowHudToolsListEl.style.padding = "4px 6px";
    workflowHudToolsListEl.style.borderRadius = "10px";
    workflowHudToolsListEl.style.background = "rgba(255,255,255,0.04)";
    workflowHudToolsListEl.style.border = "1px solid rgba(255,255,255,0.08)";
    workflowHudToolsListEl.style.boxShadow = "inset 0 1px 0 rgba(255,255,255,0.04)";
    workflowHudToolsListEl.style.minHeight = "42px";

    if (!completedToolSteps.length) {
      const empty = document.createElement("div");
      empty.textContent = "Nessun tool cliccato correttamente";
      empty.style.color = "rgba(255,255,255,0.62)";
      empty.style.fontSize = "12px";
      empty.style.fontWeight = "700";
      empty.style.lineHeight = "1.25";
      empty.style.textAlign = "left";
      empty.style.padding = "4px 2px";
      workflowHudToolsListEl.appendChild(empty);
      return;
    }

    const row = document.createElement("div");
    row.style.display = "flex";
    row.style.marginTop = "0px";
    row.style.flexWrap = "wrap";
    row.style.alignItems = "flex-start";
    row.style.gap = "8px";

    completedToolSteps.forEach((step) => {
      const tool = findToolById(step.pulse_tool_id);

      const item = document.createElement("div");
      item.style.width = "52px";
      item.style.display = "flex";
      item.style.flexDirection = "column";
      item.style.alignItems = "center";
      item.style.gap = "4px";
      item.style.flex = "0 0 auto";

      const thumb = document.createElement("div");
      thumb.style.width = "38px";
      thumb.style.height = "38px";
      thumb.style.marginTop = "-1px";
      thumb.style.borderRadius = "14px";
      thumb.style.background = "linear-gradient(180deg, rgba(255,255,255,0.10), rgba(255,255,255,0.04))";
      thumb.style.border = "1px solid rgba(255,255,255,0.10)";
      thumb.style.display = "flex";
      thumb.style.alignItems = "center";
      thumb.style.justifyContent = "center";
      thumb.style.padding = "5px";
      thumb.style.boxShadow = `
        0 6px 14px rgba(0,0,0,0.18),
        inset 0 1px 0 rgba(255,255,255,0.06)
      `;
      thumb.title = tool?.name || `Tool ${step.pulse_tool_id}`;

      if (tool?.image_url) {
        const img = document.createElement("img");
        img.src = tool.image_url;
        img.alt = tool?.name || "";
        img.loading = "lazy";
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "contain";
        img.style.objectPosition = "center";
        img.style.display = "block";
        thumb.appendChild(img);
      } else {
        thumb.textContent = "🔧";
        thumb.style.fontSize = "20px";
      }

      item.appendChild(thumb);
      row.appendChild(item);
    });

    workflowHudToolsListEl.appendChild(row);
  }

  function renderWorkflowHud() {
    renderWorkflowHudSteps();
    renderWorkflowHudTools();
  }

  /* =========================
   * WORKFLOW FEEDBACK OVERLAY
   * ========================= */
  let workflowFeedbackEl = document.getElementById("workflow-feedback-overlay");
  let workflowFeedbackCardEl = document.getElementById("workflow-feedback-card");
  let workflowFeedbackTextEl = document.getElementById("workflow-feedback-text");
  let workflowFeedbackTimer = null;

  function ensureWorkflowFeedback() {
    if (!workflowFeedbackEl) {
      workflowFeedbackEl = document.getElementById("workflow-feedback-overlay");
      workflowFeedbackCardEl = document.getElementById("workflow-feedback-card");
      workflowFeedbackTextEl = document.getElementById("workflow-feedback-text");
    }
    return workflowFeedbackEl;
  }

  function applyWorkflowFeedbackBaseStyles() {
    if (!workflowFeedbackEl || !workflowFeedbackCardEl || !workflowFeedbackTextEl) return;

    workflowFeedbackEl.style.position = "absolute";
    workflowFeedbackEl.style.left = "50%";
    workflowFeedbackEl.style.top = "50%";
    workflowFeedbackEl.style.transform = "translate(-50%, -50%)";
    workflowFeedbackEl.style.zIndex = "60";
    workflowFeedbackEl.style.maxWidth = "min(760px, 92vw)";
    workflowFeedbackEl.style.width = "max-content";
    workflowFeedbackEl.style.pointerEvents = "none";
    workflowFeedbackEl.style.opacity = "0";
    workflowFeedbackEl.style.transition = "opacity 280ms ease, transform 280ms ease";
    workflowFeedbackEl.style.display = "none";

    workflowFeedbackCardEl.style.position = "relative";
    workflowFeedbackCardEl.style.padding = "14px 22px";
    workflowFeedbackCardEl.style.borderRadius = "18px";
    workflowFeedbackCardEl.style.border = "1px solid rgba(255,255,255,0.28)";
    workflowFeedbackCardEl.style.background = "rgba(17, 24, 39, 0.42)";
    workflowFeedbackCardEl.style.backdropFilter = "blur(10px)";
    workflowFeedbackCardEl.style.webkitBackdropFilter = "blur(10px)";
    workflowFeedbackCardEl.style.boxShadow = `
      0 14px 36px rgba(0,0,0,0.28),
      inset 0 1px 0 rgba(255,255,255,0.22),
      inset 0 -1px 0 rgba(255,255,255,0.08)
    `;
    workflowFeedbackCardEl.style.overflow = "hidden";

    workflowFeedbackTextEl.style.position = "relative";
    workflowFeedbackTextEl.style.zIndex = "2";
    workflowFeedbackTextEl.style.color = "#ffffff";
    workflowFeedbackTextEl.style.fontSize = "20px";
    workflowFeedbackTextEl.style.lineHeight = "1.25";
    workflowFeedbackTextEl.style.fontWeight = "800";
    workflowFeedbackTextEl.style.letterSpacing = "0.02em";
    workflowFeedbackTextEl.style.textAlign = "center";
    workflowFeedbackTextEl.style.textShadow = `
      0 2px 10px rgba(0,0,0,0.35),
      0 1px 0 rgba(255,255,255,0.10)
    `;
  }

  function setWorkflowFeedbackTone(tone = "neutral") {
    const card = workflowFeedbackCardEl;
    const text = workflowFeedbackTextEl;
    if (!card || !text) return;

    if (tone === "danger") {
      card.style.background = "rgba(190, 24, 24, 0.42)";
      card.style.border = "1px solid rgba(254, 202, 202, 0.58)";
      card.style.boxShadow = `
        0 16px 40px rgba(80,0,0,0.42),
        0 0 0 1px rgba(255,120,120,0.18),
        inset 0 1px 0 rgba(255,255,255,0.18)
      `;
      text.style.color = "#fff7f7";
    } else if (tone === "warning") {
      card.style.background = "rgba(217, 119, 6, 0.42)";
      card.style.border = "1px solid rgba(253, 230, 138, 0.58)";
      card.style.boxShadow = `
        0 16px 40px rgba(120,60,0,0.38),
        0 0 0 1px rgba(255,200,110,0.16),
        inset 0 1px 0 rgba(255,255,255,0.18)
      `;
      text.style.color = "#fffaf0";
    } else if (tone === "positive") {
      card.style.background = "rgba(5, 150, 105, 0.40)";
      card.style.border = "1px solid rgba(167, 243, 208, 0.58)";
      card.style.boxShadow = `
        0 16px 40px rgba(0,70,45,0.36),
        0 0 0 1px rgba(110,255,200,0.14),
        inset 0 1px 0 rgba(255,255,255,0.18)
      `;
      text.style.color = "#f4fffb";
    } else {
      card.style.background = "rgba(17, 24, 39, 0.42)";
      card.style.border = "1px solid rgba(255,255,255,0.24)";
      card.style.boxShadow = `
        0 16px 40px rgba(0,0,0,0.32),
        inset 0 1px 0 rgba(255,255,255,0.16)
      `;
      text.style.color = "#ffffff";
    }
  }

  function showWorkflowFeedback(message, tone = "neutral") {
    if (!message) return;

    const box = ensureWorkflowFeedback();
    if (!box || !workflowFeedbackTextEl) return;

    if (workflowFeedbackTimer) {
      clearTimeout(workflowFeedbackTimer);
      workflowFeedbackTimer = null;
    }

    workflowFeedbackTextEl.textContent = message;
    setWorkflowFeedbackTone(tone);

    box.style.display = "block";
    box.style.transform = "translate(-50%, -50%) scale(0.96)";

    requestAnimationFrame(() => {
      box.style.opacity = "1";
      box.style.transform = "translate(-50%, -50%) scale(1)";
    });

    workflowFeedbackTimer = setTimeout(() => {
      box.style.opacity = "0";
      box.style.transform = "translate(-50%, -50%) scale(0.98)";
      setTimeout(() => {
        if (workflowFeedbackEl) workflowFeedbackEl.style.display = "none";
      }, 280);
    }, 5000);
  }

  /* =========================
   * SCREEN FX OVERLAY
   * ========================= */
  let screenFxEl = document.getElementById("screen-fx-overlay");
  let screenFxHideTimer = null;
  let screenFxPulseTimer = null;

  function ensureScreenFxOverlay() {
    if (!screenFxEl) {
      screenFxEl = document.getElementById("screen-fx-overlay");
    }
    return screenFxEl;
  }

  function applyScreenFxBaseStyles() {
    if (!screenFxEl) return;

    screenFxEl.style.position = "absolute";
    screenFxEl.style.inset = "0";
    screenFxEl.style.zIndex = "55";
    screenFxEl.style.pointerEvents = "none";
    screenFxEl.style.opacity = "0";
    screenFxEl.style.mixBlendMode = "normal";
    screenFxEl.style.transition = "opacity 220ms ease";
    screenFxEl.style.display = "none";
    screenFxEl.style.background = `
      radial-gradient(ellipse at center,
        rgba(255, 0, 0, 0) 48%,
        rgba(255, 0, 0, 0.03) 60%,
        rgba(255, 40, 40, 0.10) 70%,
        rgba(220, 0, 0, 0.22) 82%,
        rgba(160, 0, 0, 0.48) 92%,
        rgba(120, 0, 0, 0.72) 100%
      ),
      radial-gradient(circle at 8% 10%,
        rgba(255, 90, 90, 0.42) 0%,
        rgba(255, 0, 0, 0) 18%
      ),
      radial-gradient(circle at 90% 12%,
        rgba(255, 90, 90, 0.40) 0%,
        rgba(255, 0, 0, 0) 18%
      ),
      radial-gradient(circle at 6% 88%,
        rgba(255, 70, 70, 0.42) 0%,
        rgba(255, 0, 0, 0) 18%
      ),
      radial-gradient(circle at 92% 90%,
        rgba(255, 70, 70, 0.40) 0%,
        rgba(255, 0, 0, 0) 18%
      ),
      linear-gradient(to right,
        rgba(180, 0, 0, 0.42) 0%,
        rgba(255, 0, 0, 0) 12%,
        rgba(255, 0, 0, 0) 88%,
        rgba(180, 0, 0, 0.42) 100%
      ),
      linear-gradient(to bottom,
        rgba(180, 0, 0, 0.32) 0%,
        rgba(255, 0, 0, 0) 12%,
        rgba(255, 0, 0, 0) 88%,
        rgba(180, 0, 0, 0.34) 100%
      )
    `;
    screenFxEl.style.filter = "blur(1.5px) saturate(1.15)";
  }

  function setScreenFxIntensity(level = "danger") {
    const fx = ensureScreenFxOverlay();
    if (!fx) return;

    if (level === "warning") {
      fx.style.background = `
        radial-gradient(ellipse at center,
          rgba(255, 110, 0, 0) 50%,
          rgba(255, 120, 0, 0.04) 62%,
          rgba(255, 110, 0, 0.10) 74%,
          rgba(220, 70, 0, 0.18) 84%,
          rgba(170, 40, 0, 0.36) 93%,
          rgba(120, 25, 0, 0.54) 100%
        ),
        radial-gradient(circle at 8% 10%,
          rgba(255, 175, 80, 0.28) 0%,
          rgba(255, 110, 0, 0) 18%
        ),
        radial-gradient(circle at 90% 12%,
          rgba(255, 175, 80, 0.26) 0%,
          rgba(255, 110, 0, 0) 18%
        ),
        radial-gradient(circle at 6% 88%,
          rgba(255, 145, 60, 0.28) 0%,
          rgba(255, 110, 0, 0) 18%
        ),
        radial-gradient(circle at 92% 90%,
          rgba(255, 145, 60, 0.26) 0%,
          rgba(255, 110, 0, 0) 18%
        ),
        linear-gradient(to right,
          rgba(180, 70, 0, 0.24) 0%,
          rgba(255, 110, 0, 0) 12%,
          rgba(255, 110, 0, 0) 88%,
          rgba(180, 70, 0, 0.24) 100%
        ),
        linear-gradient(to bottom,
          rgba(180, 70, 0, 0.20) 0%,
          rgba(255, 110, 0, 0) 12%,
          rgba(255, 110, 0, 0) 88%,
          rgba(180, 70, 0, 0.20) 100%
        )
      `;
      fx.style.filter = "blur(1.2px) saturate(1.08)";
    } else {
      fx.style.background = `
        radial-gradient(ellipse at center,
          rgba(255, 0, 0, 0) 48%,
          rgba(255, 0, 0, 0.03) 60%,
          rgba(255, 40, 40, 0.10) 70%,
          rgba(220, 0, 0, 0.22) 82%,
          rgba(160, 0, 0, 0.48) 92%,
          rgba(120, 0, 0, 0.72) 100%
        ),
        radial-gradient(circle at 8% 10%,
          rgba(255, 90, 90, 0.42) 0%,
          rgba(255, 0, 0, 0) 18%
        ),
        radial-gradient(circle at 90% 12%,
          rgba(255, 90, 90, 0.40) 0%,
          rgba(255, 0, 0, 0) 18%
        ),
        radial-gradient(circle at 6% 88%,
          rgba(255, 70, 70, 0.42) 0%,
          rgba(255, 0, 0, 0) 18%
        ),
        radial-gradient(circle at 92% 90%,
          rgba(255, 70, 70, 0.40) 0%,
          rgba(255, 0, 0, 0) 18%
        ),
        linear-gradient(to right,
          rgba(180, 0, 0, 0.42) 0%,
          rgba(255, 0, 0, 0) 12%,
          rgba(255, 0, 0, 0) 88%,
          rgba(180, 0, 0, 0.42) 100%
        ),
        linear-gradient(to bottom,
          rgba(180, 0, 0, 0.32) 0%,
          rgba(255, 0, 0, 0) 12%,
          rgba(255, 0, 0, 0) 88%,
          rgba(180, 0, 0, 0.34) 100%
        )
      `;
      fx.style.filter = "blur(1.5px) saturate(1.15)";
    }
  }

  function showScreenFx(level = "danger", duration = 1400) {
    const fx = ensureScreenFxOverlay();
    if (!fx) return;

    setScreenFxIntensity(level);

    if (screenFxHideTimer) {
      clearTimeout(screenFxHideTimer);
      screenFxHideTimer = null;
    }

    if (screenFxPulseTimer) {
      clearInterval(screenFxPulseTimer);
      screenFxPulseTimer = null;
    }

    const high = level === "danger" ? 1 : 0.72;
    const low = level === "danger" ? 0.72 : 0.48;

    fx.style.display = "block";
    fx.style.opacity = String(high);

    screenFxPulseTimer = setInterval(() => {
      fx.style.opacity = fx.style.opacity === String(high) ? String(low) : String(high);
    }, 160);

    screenFxHideTimer = setTimeout(() => {
      if (screenFxPulseTimer) {
        clearInterval(screenFxPulseTimer);
        screenFxPulseTimer = null;
      }

      fx.style.opacity = "0";

      setTimeout(() => {
        if (screenFxEl) screenFxEl.style.display = "none";
      }, 240);
    }, duration);
  }

  function handleWorkflowFeedback(result) {
    if (!result) {
      renderWorkflowHud();
      return;
    }

    const tone = result.feedback_tone || "neutral";

    if (result.message) {
      showWorkflowFeedback(result.message, tone);
    }

    if (tone === "danger") {
      showScreenFx("danger", 1700);
    } else if (tone === "warning") {
      showScreenFx("warning", 1200);
    }

    renderWorkflowHud();
  }

  // tool associati ad almeno un hotspot = tool da drag, NON da click workflow
  const assignedToolIds = new Set(
    (sceneData?.hotspots || [])
      .flatMap((h) => h.pulse_tool_ids || [])
      .map((id) => String(id))
  );

  // toolbox runtime: ogni tool è o click o drag
  const runtimeToolboxes = (sceneData?.toolboxes || sceneData?.pulse_toolboxes || []).map((tb) => ({
    ...tb,
    tools: (tb.tools || []).map((tool) => {
      const isDraggable = assignedToolIds.has(String(tool.id));

      return {
        ...tool,
        is_draggable: isDraggable,
        is_clickable: !isDraggable,
      };
    }),
  }));

  /* =========================
   * SCENE / CAMERA / RENDERER
   * ========================= */
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x000000);

  const camera = new THREE.PerspectiveCamera(
    58,
    el.clientWidth / el.clientHeight,
    0.1,
    5000
  );
  camera.position.set(0, 0, 0);

  const renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(el.clientWidth, el.clientHeight);
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  el.appendChild(renderer.domElement);

  renderer.domElement.style.touchAction = "none";
  renderer.domElement.style.userSelect = "none";

  /* =========================
   * CILINDRO 180°
   * ========================= */
  const R = 1400;
  const SEG = 256;

  const THETA_LENGTH = Math.PI;
  const THETA_START = -Math.PI / 2;

  let H = computeInitialHeight();

  function computeInitialHeight() {
    const vFovRad = THREE.MathUtils.degToRad(camera.fov);
    return 2 * R * Math.tan(vFovRad / 2);
  }

  function makeCylinderGeometry(height) {
    return new THREE.CylinderGeometry(
      R,
      R,
      height,
      SEG,
      1,
      true,
      THETA_START,
      THETA_LENGTH
    );
  }

  let geometry = makeCylinderGeometry(H);

  const material = new THREE.MeshBasicMaterial({
    side: THREE.BackSide,
    color: 0xffffff,
  });

  const pano = new THREE.Mesh(geometry, material);
  scene.add(pano);

  /* =========================
   * CENTRATURA
   * ========================= */
  const LOOK_OFFSET_DEG = 90;
  const CENTER_OFFSET_DEG = 0;

  /* =========================
   * LIMITI DINAMICI
   * ========================= */
  let lonLimitDeg = 85;
  let latLimitDeg = 3;

  function computeLimitsDeg() {
    const vFov = THREE.MathUtils.degToRad(camera.fov);
    const hFov = 2 * Math.atan(Math.tan(vFov / 2) * camera.aspect);

    const halfArc = THETA_LENGTH / 2;
    const halfView = hFov / 2;

    const marginLon = 0.01;
    const limitLonRad = Math.max(0, halfArc - halfView - marginLon);
    lonLimitDeg = THREE.MathUtils.radToDeg(limitLonRad);

    latLimitDeg = 3;
  }

  /* =========================
   * STATO / CLAMP
   * ========================= */
  let lon = 0;
  let lat = 0;

  const clampAngles = () => {
    lon = Math.max(-lonLimitDeg, Math.min(lonLimitDeg, lon));
    lat = Math.max(-latLimitDeg, Math.min(latLimitDeg, lat));
  };

  /* =========================
   * HOTSPOT LAYER + INTERACTIONS
   * ========================= */
  let interactions = null;

  const hotspotLayer = createHotspotLayer({
    containerEl: el,
    camera,
    radius: R,
    lookOffsetDeg: LOOK_OFFSET_DEG,
    centerOffsetDeg: CENTER_OFFSET_DEG,
    hotspots: [],
    onHotspotClick: ({ hotspot }) => {
      console.log("[HOTSPOT] click:", hotspot);

      const result = workflowRuntime.tryHotspotFlow(hotspot?.id);
      console.log("[WORKFLOW] hotspot click result:", result, hotspot);

      handleWorkflowFeedback(result);

      const shouldBlockHotspot = !result?.ok;

      if (shouldBlockHotspot && hotspot?.id) {
        interactions?.clearActive?.(hotspot.id);
        return;
      }

      interactions?.toggleActive?.(hotspot?.id);
    },
  });

  interactions = createInteractions({
    containerEl: el,
    hotspotLayer,
    onSelect: (payload) => {
      console.log("SELECT", payload?.id, payload?.hotspot?.name);
    },
    onDeselect: ({ id }) => {
      console.log("DESELECT", id);
    },
  });

  /* =========================
   * TOOL HELPERS
   * ========================= */
  function findToolById(toolId) {
    const id = String(toolId);
    const tbs = sceneData?.toolboxes || sceneData?.pulse_toolboxes || [];
    for (const tb of tbs) {
      const found = (tb.tools || []).find((t) => String(t.id) === id);
      if (found) return found;
    }
    return null;
  }

  function findHotspotById(hotspotId) {
    return (
      (sceneData?.hotspots || []).find((h) => String(h.id) === String(hotspotId)) ||
      null
    );
  }

  function ensureAttachmentsWrap(hotspotEl) {
    let wrap = hotspotEl.querySelector(".hs-dot__attachments");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "hs-dot__attachments";
      hotspotEl.appendChild(wrap);
    }
    return wrap;
  }

  function refreshHotspotHasTool(hotspotEl) {
    if (!hotspotEl) return;

    const wrap = hotspotEl.querySelector(".hs-dot__attachments");
    const hasAny = !!wrap && wrap.querySelector(".hs-attach");

    hotspotEl.classList.toggle("hs-has-tool", !!hasAny);
  }

  function attachToolToHotspot({ hotspotEl, tool }) {
    if (!hotspotEl || !tool) return;

    const wrap = ensureAttachmentsWrap(hotspotEl);

    if (wrap.querySelector(`[data-attached-tool-id="${String(tool.id)}"]`)) {
      refreshHotspotHasTool(hotspotEl);
      return;
    }

    const item = document.createElement("div");
    item.className = "hs-attach";
    item.dataset.attachedToolId = String(tool.id);

    if (tool.image_url) {
      const img = document.createElement("img");
      img.src = tool.image_url;
      img.alt = tool.name || "";
      img.loading = "lazy";

      img.className = "hs-attach__img";
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.objectFit = "contain";
      img.style.objectPosition = "center";
      img.style.display = "block";

      item.appendChild(img);
    } else {
      item.textContent = "🔧";
      item.style.display = "flex";
      item.style.alignItems = "center";
      item.style.justifyContent = "center";
      item.style.fontSize = "14px";
    }

    wrap.appendChild(item);
    refreshHotspotHasTool(hotspotEl);
  }

  function flashDenied(hotspotEl) {
    if (!hotspotEl) return;
    hotspotEl.classList.add("is-drop-denied");
    setTimeout(() => hotspotEl.classList.remove("is-drop-denied"), 220);
  }

  /* =========================
   * DRAG&DROP Tools -> Hotspots
   * ========================= */
  const dnd = initToolsDragDrop({
    rootEl: document,
    onAssign: async ({ toolId, hotspotId, hotspotEl }) => {
      const hs = findHotspotById(hotspotId);
      if (!hs) return;

      const workflowResult = workflowRuntime.tryToolDrop(toolId, hotspotId);
      console.log("[WORKFLOW] tool drop result:", workflowResult, { toolId, hotspotId });

      handleWorkflowFeedback(workflowResult);

      const shouldBlockDrop =
        !workflowResult?.ok || workflowResult?.ignored === true;

      if (shouldBlockDrop) {
        flashDenied(hotspotEl);
        return;
      }

      const allowedByHotspot = (hs.pulse_tool_ids || [])
        .map(String)
        .includes(String(toolId));

      if (!allowedByHotspot) {
        console.log("[WORKFLOW] blocked: structurally_not_allowed", { toolId, hotspotId });
        flashDenied(hotspotEl);
        return;
      }

      const tool = findToolById(toolId);
      if (!tool) return;

      attachToolToHotspot({ hotspotEl, tool });
    },
  });

  /* =========================
   * TEXTURE LOADER
   * ========================= */
  const input = document.getElementById("pano-input");
  const loader = new THREE.TextureLoader();
  let currentTex = null;

  function fitCylinderToTexture(tex) {
    const img = tex?.image;
    const w = img?.naturalWidth || img?.videoWidth || img?.width || 0;
    const h = img?.naturalHeight || img?.videoHeight || img?.height || 0;

    if (!w || !h) return;

    const imageAspect = w / h;
    const arcLen = R * THETA_LENGTH;

    let idealH = arcLen / imageAspect;

    const vFovRad = THREE.MathUtils.degToRad(camera.fov);
    const viewH = 2 * R * Math.tan(vFovRad / 2);

    const minH = viewH * 0.85;
    const maxH = viewH * 1.6;
    idealH = Math.max(minH, Math.min(maxH, idealH));

    if (Math.abs(idealH - H) > 0.5) {
      H = idealH;

      const newGeo = makeCylinderGeometry(H);
      geometry.dispose();
      geometry = newGeo;
      pano.geometry = geometry;

      computeLimitsDeg();
      clampAngles();
      hotspotLayer.update();
    }
  }

  function applyTexture(tex) {
    if (currentTex) currentTex.dispose();
    currentTex = tex;

    tex.colorSpace = THREE.SRGBColorSpace;
    tex.flipY = true;
    tex.wrapS = THREE.ClampToEdgeWrapping;
    tex.wrapT = THREE.ClampToEdgeWrapping;

    tex.generateMipmaps = true;
    tex.minFilter = THREE.LinearMipmapLinearFilter;
    tex.magFilter = THREE.LinearFilter;

    const maxAniso = renderer.capabilities.getMaxAnisotropy?.() || 1;
    tex.anisotropy = Math.min(8, maxAniso);

    tex.repeat.x = -1;
    tex.offset.x = 1;

    fitCylinderToTexture(tex);

    material.map = tex;
    material.needsUpdate = true;
  }

  function setTextureFromFile(file) {
    if (!file) return;

    const url = URL.createObjectURL(file);
    loader.load(
      url,
      (tex) => {
        applyTexture(tex);

        lon = 0;
        lat = 0;
        clampAngles();
        updateButtons();
        hotspotLayer.update();
      },
      undefined,
      (err) => console.error("Texture load error", err)
    );
  }

  function setTextureFromUrl(url) {
    if (!url) return;

    console.log("[SCENE] loading texture:", url);

    loader.load(
      url,
      (tex) => {
        console.log("[SCENE] texture loaded:", tex.image?.width, tex.image?.height);
        applyTexture(tex);

        lon = 0;
        lat = 0;
        clampAngles();
        updateButtons();
        hotspotLayer.update();
      },
      undefined,
      (err) => console.error("[SCENE] texture load error:", url, err)
    );
  }

  input?.addEventListener("change", (e) => setTextureFromFile(e.target.files?.[0]));

  /* =========================
   * LOAD SCENE (Rails JSON)
   * ========================= */
  if (sceneData?.background_image_url) {
    console.log("[SCENE] Rails scene:", sceneData.id, sceneData.title);
    setTextureFromUrl(sceneData.background_image_url);

    const hs = sceneData?.hotspots || [];
    hotspotLayer.setHotspots(hs);
    hotspotLayer.update();
  } else {
    console.warn("[SCENE] background_image_url mancante in scene-data");
  }

  ensureWorkflowHud();
  applyWorkflowHudBaseStyles();
  ensureWorkflowFeedback();
  applyWorkflowFeedbackBaseStyles();
  ensureScreenFxOverlay();
  applyScreenFxBaseStyles();
  renderWorkflowHud();

  /* =========================
   * TOOLBOX PANEL (destra)
   * ========================= */
  const toolboxesMount = document.getElementById("pano-toolboxes");

  const toolboxesPanel = createToolboxesPanel({
    mountEl: toolboxesMount,
    toolboxes: runtimeToolboxes,

    onToolboxTabClick: () => {
      const step = workflowRuntime.currentStep?.();
      if (!step) return true;

      const isRequiredHotspotStep =
        step.kind === "hotspot_flow" &&
        (step.severity || "required") === "required";

      if (!isRequiredHotspotStep) return true;

      handleWorkflowFeedback({
        ok: false,
        blocked: true,
        feedback_tone: "danger",
        message: step.message || "",
      });

      return false;
    },

    onToolClick: (tool) => {
      if (assignedToolIds.has(String(tool.id))) return;

      const result = workflowRuntime.tryToolClick(tool.id);
      console.log("[WORKFLOW] tool click result:", result, tool);

      handleWorkflowFeedback(result);
    },
  });

  /* =========================
   * PAN BLOCKER (UI)
   * ========================= */
  let blockPan = false;

  const PAN_BLOCK_SELECTORS = [
    ".hs-dot",
    ".hs-tooltip",
    ".hs-tooltip *",
    ".hs-tooltip__btn",
    ".hs-tooltip__choice",
    ".hs-dot__attachments",
    ".hs-attach",
  ];

  function isUiTarget(target) {
    if (!target?.closest) return false;
    return PAN_BLOCK_SELECTORS.some((sel) => target.closest(sel));
  }

  const onUiPointerDownCapture = (e) => {
    if (isUiTarget(e.target)) blockPan = true;
  };

  const onUiPointerUpCapture = () => {
    blockPan = false;
  };

  el.addEventListener("pointerdown", onUiPointerDownCapture, true);
  el.addEventListener("pointerup", onUiPointerUpCapture, true);
  el.addEventListener("pointercancel", onUiPointerUpCapture, true);

  /* =========================
   * POINTER DRAG
   * ========================= */
  let isUserInteracting = false;
  let onPointerDownX = 0;
  let onPointerDownY = 0;
  let onPointerDownLon = 0;
  let onPointerDownLat = 0;

  function onPointerDown(e) {
    if (blockPan) return;

    e.preventDefault();
    isUserInteracting = true;
    onPointerDownX = e.clientX;
    onPointerDownY = e.clientY;
    onPointerDownLon = lon;
    onPointerDownLat = lat;
  }

  function onPointerMove(e) {
    if (!isUserInteracting) return;

    lon = (onPointerDownX - e.clientX) * 0.1 + onPointerDownLon;
    lat = (e.clientY - onPointerDownY) * 0.08 + onPointerDownLat;

    clampAngles();
  }

  function onPointerUp() {
    isUserInteracting = false;
  }

  renderer.domElement.addEventListener("pointerdown", onPointerDown);
  renderer.domElement.addEventListener("pointermove", onPointerMove);
  renderer.domElement.addEventListener("pointerup", onPointerUp);
  renderer.domElement.addEventListener("pointercancel", onPointerUp);

  /* =========================
   * TASTIERA
   * ========================= */
  let keyLeft = false;
  let keyRight = false;
  let keyUp = false;
  let keyDown = false;

  const KEY_SPEED_LON = 60;
  const KEY_SPEED_LAT = 45;

  function onKeyDown(e) {
    if (e.code === "ArrowLeft" || e.code === "KeyA") {
      keyLeft = true;
      e.preventDefault();
    }
    if (e.code === "ArrowRight" || e.code === "KeyD") {
      keyRight = true;
      e.preventDefault();
    }
    if (e.code === "ArrowUp" || e.code === "KeyW") {
      keyUp = true;
      e.preventDefault();
    }
    if (e.code === "ArrowDown" || e.code === "KeyS") {
      keyDown = true;
      e.preventDefault();
    }

    if (e.code === "Space") {
      e.preventDefault();
      lon = 0;
      lat = 0;
      clampAngles();
      updateButtons();
    }
  }

  function onKeyUp(e) {
    if (e.code === "ArrowLeft" || e.code === "KeyA") keyLeft = false;
    if (e.code === "ArrowRight" || e.code === "KeyD") keyRight = false;
    if (e.code === "ArrowUp" || e.code === "KeyW") keyUp = false;
    if (e.code === "ArrowDown" || e.code === "KeyS") keyDown = false;
  }

  window.addEventListener("keydown", onKeyDown);
  window.addEventListener("keyup", onKeyUp);

  /* =========================
   * BOTTONI UI (hold) + CENTER
   * ========================= */
  const btnLeft = document.getElementById("pano-left");
  const btnRight = document.getElementById("pano-right");
  const btnCenter = document.getElementById("pano-center");

  let uiLeft = false;
  let uiRight = false;

  function updateButtons() {
    const leftPressed = uiLeft || keyLeft;
    const rightPressed = uiRight || keyRight;

    btnLeft?.classList.toggle("active", leftPressed);
    btnRight?.classList.toggle("active", rightPressed);

    const isCentered = Math.abs(lon) < 0.1 && Math.abs(lat) < 0.1;
    btnCenter?.classList.toggle("active", !isCentered);
  }

  function bindHoldButton(btn, dir) {
    if (!btn) return;

    const set = (v) => {
      if (dir === "left") uiLeft = v;
      if (dir === "right") uiRight = v;
      updateButtons();
    };

    btn.addEventListener("pointerdown", (e) => {
      e.preventDefault();
      btn.setPointerCapture?.(e.pointerId);
      set(true);
    });

    const release = (e) => {
      try {
        btn.releasePointerCapture?.(e.pointerId);
      } catch (_) {}
      set(false);
    };

    btn.addEventListener("pointerup", release);
    btn.addEventListener("pointercancel", release);
    btn.addEventListener("pointerleave", () => set(false));
  }

  bindHoldButton(btnLeft, "left");
  bindHoldButton(btnRight, "right");

  btnCenter?.addEventListener("pointerdown", (e) => {
    e.preventDefault();
    lon = 0;
    lat = 0;
    clampAngles();
    updateButtons();
  });

  /* =========================
   * LOOP
   * ========================= */
  let lastTime = performance.now();

  function animate(time) {
    requestAnimationFrame(animate);

    const dt = (time - lastTime) / 1000;
    lastTime = time;

    if (keyLeft || uiLeft) lon -= KEY_SPEED_LON * dt;
    if (keyRight || uiRight) lon += KEY_SPEED_LON * dt;

    if (keyUp) lat += KEY_SPEED_LAT * dt;
    if (keyDown) lat -= KEY_SPEED_LAT * dt;

    clampAngles();

    const theta = THREE.MathUtils.degToRad(lon + LOOK_OFFSET_DEG + CENTER_OFFSET_DEG);
    const phi = THREE.MathUtils.degToRad(90 - lat);

    const target = new THREE.Vector3(
      R * Math.sin(phi) * Math.cos(theta),
      R * Math.cos(phi),
      R * Math.sin(phi) * Math.sin(theta)
    );

    camera.lookAt(target);
    renderer.render(scene, camera);

    hotspotLayer.update();
    interactions.update();
    updateButtons();
  }

  requestAnimationFrame(animate);

  /* =========================
   * RESIZE
   * ========================= */
  function onResize() {
    camera.aspect = el.clientWidth / el.clientHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(el.clientWidth, el.clientHeight);

    if (currentTex) fitCylinderToTexture(currentTex);

    computeLimitsDeg();
    clampAngles();
    updateButtons();
    hotspotLayer.update();
  }

  window.addEventListener("resize", onResize);

  computeLimitsDeg();
  clampAngles();
  updateButtons();
  hotspotLayer.update();
  renderWorkflowHud();

  /* =========================
   * CLEANUP
   * ========================= */
  return () => {
    window.removeEventListener("resize", onResize);
    window.removeEventListener("keydown", onKeyDown);
    window.removeEventListener("keyup", onKeyUp);

    renderer.domElement.removeEventListener("pointerdown", onPointerDown);
    renderer.domElement.removeEventListener("pointermove", onPointerMove);
    renderer.domElement.removeEventListener("pointerup", onPointerUp);
    renderer.domElement.removeEventListener("pointercancel", onPointerUp);

    el.removeEventListener("pointerdown", onUiPointerDownCapture, true);
    el.removeEventListener("pointerup", onUiPointerUpCapture, true);
    el.removeEventListener("pointercancel", onUiPointerUpCapture, true);

    hotspotLayer.destroy();
    interactions.destroy();
    toolboxesPanel?.destroy?.();
    dnd?.destroy?.();

    if (workflowFeedbackTimer) {
      clearTimeout(workflowFeedbackTimer);
      workflowFeedbackTimer = null;
    }

    if (screenFxHideTimer) {
      clearTimeout(screenFxHideTimer);
      screenFxHideTimer = null;
    }

    if (screenFxPulseTimer) {
      clearInterval(screenFxPulseTimer);
      screenFxPulseTimer = null;
    }

    if (currentTex) currentTex.dispose();

    geometry.dispose();
    material.dispose();
    renderer.dispose();
    el.innerHTML = "";
  };
}